import { Wrapper } from './styles'
import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import DeliveryOptions from './DeliveryOptions'
import DeliveryByEmailForm from './DeliveryByEmailForm'
import DeliveryByPostForm from './DeliveryByPostForm'
import { useAppSelector } from 'store/hooks'

const VouchersDeliveryOptions = () => {
    const { formatMessage } = useIntl()
    const { deliveryType } = useAppSelector((state) => state.order.shipping)

    return (
        <Wrapper>
            <Box pb={[24, 30]} isFullWidth>
                <Text variant="heading2">
                    {formatMessage({
                        id: 'selfcare.payment.voucher_header',
                        defaultMessage: 'Szczegóły Vouchera',
                    })}
                </Text>
            </Box>
            <DeliveryOptions />
            {deliveryType === 'email' ? (
                <DeliveryByEmailForm />
            ) : (
                <DeliveryByPostForm />
            )}
        </Wrapper>
    )
}

export default VouchersDeliveryOptions
